import WinController from './winController';
import SoundManager from 'Engine/soundManager/SoundManager';
import { gsap } from 'gsap';
import EntryPoint from 'Engine/EntryPoint';
import ParticleSystem from 'Engine/particles/particleSystem';
import particlesConfig from 'Engine/particles/particleConfig';

export default class SmallWinController extends WinController {
  constructor(props) {
    super(props);
  }

  onStart() {
    if (EntryPoint.GameModel.extraCoef > 1) {
      this.counter.visible = false;
      this.smallWinCounter.visible = true;
      this.totalWinCounter.visible = true;
      this.coefCounter.visible = true;
      this.coefCounter.label.text = `×${EntryPoint.GameModel.extraCoef}`;
      this.coefCounter.label.visible = true;
      this.panelBig.visible = true;
      this.totalWinCounter.set(EntryPoint.GameModel.totalWin);
      this.panelBig.children[0].width = this.totalWinCounter.label.width + 325;
      this.createParticlesForBigPanel();
    } else  {
      this.counter.visible = true;
      this.smallWinCounter.visible = false;
      this.totalWinCounter.visible = false;
      this.coefCounter.visible = false;
      this.coefCounter.label.visible = false;
      this.panelSmall.visible = true;
      this.smallWinCounter.set(EntryPoint.GameModel.totalWin);
      this.panelSmall.children[0].width = this.smallWinCounter.label.width*1.6 + 240;
      this.createParticlesForSmallPanel();
    }


    this.setDurationOnNextCall(3000 * (-1/(EntryPoint.GameModel.totalWin / EntryPoint.GameModel.bet + 1) + 1) + this._config.duration); // y = 3000 * (-1/(x + 1) + 1) + x0

    this.ControllerPopup.stopMainBackgroundSound();
  }

  createParticlesForSmallPanel() {

    const container = new PIXI.Container();
    this.panelSmall.addChild(container);
    // this.coinsContainer.x = this.wrapper.displayData.width / 2;

    const panelImg = this.panelSmall.children[0];

    const texture = PIXI.Texture.from('starParticle');
    this.panelSmall.particles = new ParticleSystem(container, { texture: texture }, {
      ...particlesConfig.coinParticlesConfig,
      x0min: panelImg.x - panelImg.width * 1 / 3, // px
      x0max: panelImg.x + panelImg.width * 1 / 3, // px
      y0min: panelImg.height / 2 - panelImg.height * 1 / 4, // px
      y0max: panelImg.height / 2 + panelImg.height * 1 / 4, // px
      scaleStart: 1,
      scaleEnd: 0,
      angle0From: 0,
      angle0To: Math.PI * 2,
      angleVelocityMin: 0.0005,
      angleVelocityMax: 0.0006,
      v0min: 0.05, // px / milliseconds
      v0max: 0.1, // px / milliseconds
      gravityY: 0,
      mass: 0.06, // ~kg
      drag: 1 / 60,
      lifetimeMin: 1000, // milliseconds
      lifetimeMax: 2000, // milliseconds
      count: 100,
    });
  }


  createParticlesForBigPanel() {

    const container = new PIXI.Container();
    this.panelBig.addChild(container);
    // this.coinsContainer.x = this.wrapper.displayData.width / 2;

    const panelImg = this.panelBig.children[0];

    const texture = PIXI.Texture.from('starParticle');
    this.panelBig.particles = new ParticleSystem(container, { texture: texture }, {
      ...particlesConfig.coinParticlesConfig,
      x0min: panelImg.x - panelImg.width * 1 / 2.5, // px
      x0max: panelImg.x + panelImg.width * 1 / 2.5, // px
      y0min: panelImg.height / 2 - panelImg.height * 1 / 2.5, // px
      y0max: panelImg.height / 2 + panelImg.height * 1 / 2.5, // px
      scaleStart: 1,
      scaleEnd: 0,
      angle0From: 0,
      angle0To: Math.PI * 2,
      angleVelocityMin: 0.0005,
      angleVelocityMax: 0.0006,
      v0min: 0.05, // px / milliseconds
      v0max: 0.1, // px / milliseconds
      gravityY: 0,
      mass: 0.06, // ~kg
      drag: 1 / 60,
      lifetimeMin: 1000, // milliseconds
      lifetimeMax: 2000, // milliseconds
      count: 150,
    });
  }

  cleanup() {
    super.cleanup();
    if (this.panelSmall.particles) {
      this.panelSmall.particles.stop();
      this.panelSmall.particles = null;
    }
    if (this.panelBig.particles) {
      this.panelBig.particles.stop();
      this.panelBig.particles = null;
    }

    this.panelSmall.visible = false;
    this.panelBig.visible = false;
    const sound = SoundManager.getSound(this._config.sound.soundName);
    gsap.to(sound, { volume: 0, duration: 0.5, onComplete: () => sound.stop()});

    this.ControllerPopup.playMainBackgroundSound();
  }
}
